import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AddVehicleProperties, NewVehicle } from 'src/models';
import { EmptyVehicle } from 'src/models/NewVehicle/TestVehicle';
import { IStoreState } from 'src/store';

/** Interfaces */
export interface INewVehicleState {
    NewVehicle?: NewVehicle;
    CurrentProperty: AddVehicleProperties;
}

/** Initial State */
export const initialState: INewVehicleState = {
    NewVehicle: {
        vin: '',
        vinValid: false,
        makeCode: '',
        make: '',
        year: '',
        model: '',
        trim: '',
        color: 'default',
        estMileage: '',
        makeId: '',
        modelId: '',
    },
    CurrentProperty: 'make',
};

export const NewVehicleSlice = createSlice({
    name: 'NewVehicle',
    initialState: initialState as INewVehicleState,
    reducers: {
        clearNewVehicle: (state) => {
            state.NewVehicle = initialState.NewVehicle;
            state.CurrentProperty = 'make';
        },
        addNewVeh: (state, action: PayloadAction<NewVehicle>) => {
            state.NewVehicle = action.payload;
        },
        changeCurrentProperty: (state, action: PayloadAction<AddVehicleProperties>) => {
            state.CurrentProperty = action.payload;
        },
    },
});

export const {
    clearNewVehicle,
    addNewVeh,
    changeCurrentProperty,
} = NewVehicleSlice.actions;

export default NewVehicleSlice.reducer;

export function AddNewVehicle(newVehicle: NewVehicle, nextProperty?: AddVehicleProperties) {
    return (dispatch, getState: () => IStoreState) => {
        const currentVehicle = getState().NewVehicle.NewVehicle;
        let property: AddVehicleProperties = getState().NewVehicle.CurrentProperty;
        if (newVehicle === EmptyVehicle) {
            property = 'make';
        } else if (currentVehicle?.model !== newVehicle.model && newVehicle.model) {
            property = 'color';
        } else if (currentVehicle?.year !== newVehicle.year && newVehicle.year) {
            property = 'model';
        } else if (currentVehicle?.make.toUpperCase() !== newVehicle.make.toUpperCase() && newVehicle.make.toUpperCase()) {
            property = 'year';
        }

        if (nextProperty) {
            property = nextProperty;
        }

        dispatch(addNewVeh(newVehicle));
        dispatch(changeCurrentProperty(property));
    };
}

export function ClearNewVehicle() {
    return (dispatch) => {
        dispatch(clearNewVehicle());
    };
}

export function PreviousProperty() {
    return (dispatch, getState: () => IStoreState) => {
        const currentProperty = getState().NewVehicle.CurrentProperty;
        let newProperty: AddVehicleProperties = 'make';
        switch (currentProperty) {
            case 'model': {
                newProperty = 'year';
                break;
            }
            case 'color': {
                newProperty = 'model';
                break;
            }
            case 'year':
            case 'make':
            default: {
                newProperty = 'make';
                break;
            }
        }
        dispatch(changeCurrentProperty(newProperty));
    };
}